import { DEFAULT_FORMAT_DATE } from "constants/datetime";

import { Box, Grid } from "@mui/material";
import {
  DateRangePickerHookForm,
  DayjsLocalizationProvider,
  FormContainerControlled,
  TextFieldHookForm,
} from "components";
import { ButtonApply } from "components/ButtonApply/ButtonApply";
import { dayjsTZ } from "helpers/dayjs";
import { useForm } from "react-hook-form";

interface FilterProps {
  data?: any;
  onSearch?: (value: any) => void;
}

export const ReportManagementFilter = (props: FilterProps) => {
  const { data, onSearch } = props;
  const methods = useForm<any>({
    values: {
      name: data?.name ?? "",
      assignedDate:
        data?.assignedDate && data?.assignedDate?.length > 0
          ? // eslint-disable-next-line
            data?.assignedDate?.map((e: string) => {
              if (e) {
                return dayjsTZ(e);
              }
              return null;
            })
          : [null, null],
    },
  });
  const { watch } = methods;
  const onSubmit = () => {
    if (onSearch !== undefined) {
      onSearch({ ...data, ...watch() });
    }
  };

  return (
    <FormContainerControlled methods={methods} onSubmit={onSubmit}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid container spacing="12px" marginTop="0">
          <Grid item xs={12} lg={6}>
            <TextFieldHookForm
              name="name"
              label="File Name"
              placeholder="Search by keyword"
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <DayjsLocalizationProvider>
              <DateRangePickerHookForm
                format={DEFAULT_FORMAT_DATE}
                name="assignedDate"
                label="Assigned Date"
                placeholder="Select date"
              />
            </DayjsLocalizationProvider>
          </Grid>
        </Grid>

        <ButtonApply />
      </Box>
    </FormContainerControlled>
  );
};
